import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { getAllContracts } from "../../../redux/contractSlice/contractSlice";
import Logo from "../../../Images/logo192.png";
import { getAllStandardMaintenanceItems } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";
import { getAllMaintenanceScheduleById } from "../../../redux/MaintenanceScheduleSlice/MaintenanceScheduleSlice";

DataTable.use(DT);

export default function MaintenanceItemsDatatable() {
  const [maintenanceItems, setMaintenanceItems] = useState([]);
  const dispatch = useDispatch();
  const specificMaintenanceSchedule = useSelector((state) => state.maintenanceSchedule?.specificMaintenanceSchedule?.scheduleItems);
  const table = useRef();
  const [loading, setLoading] = useState(true);
  const { ScheduleId } = useParams();
  useEffect(() => {
    dispatch(getAllMaintenanceScheduleById(ScheduleId));
  }, [dispatch, ScheduleId]);

  useEffect(() => {
    if (specificMaintenanceSchedule) {
      console.log(specificMaintenanceSchedule);
      setMaintenanceItems(specificMaintenanceSchedule);
      setLoading(false);
    }
  }, [specificMaintenanceSchedule]);

  const screenColumns = [
    { title: "اسم العنصر الاساسي", data: "standardItem", render: (data) => data?.name },
    { title: "اسم العنصر بالانجليزي", data: "standardItem", render: (data) => data?.name_en },
    { title: "التصنيف", data: "standardItem", render: (data) => data?.category },
    { title: "حالة العنصر", data: "status" },
    // {
    //   title: "تاريخ البدء",
    //   data: "start_date",
    //   render: (data) => format(new Date(data), "yyyy-MM-dd"),
    // },
    // {
    //   title: "تاريخ الانتهاء",
    //   data: "end_date",
    //   render: (data) => format(new Date(data), "yyyy-MM-dd"),
    // },
    // {
    //   title: "القيمة",
    //   data: "value",
    // },
    // { title: "الحالة", data: "status" },
    // { title: "عدد زيارات الصيانة", data: "maintenance_visits" },
    // {
    //   title: `عمليات`,
    //   data: null,
    //   render: (data, type, row) =>
    //     `<div class="d-flex gap-3 justify-content-center align-items-center">
    //       <a href="/Contracts/Contract/${row.id}" class="text-decoration-none" target="_blank">
    //         <i class="fa-regular fa-eye"></i>
    //       </a>
    //       <a href="/Contracts/${row.id}/MaintenanceSchedules" class="text-decoration-none" target="_blank">
    //         <i class="fa-solid fa-table"></i>
    //       </a>
    //       <a href="/Contracts/${row.id}/AddStandardMaintenanceItem" class="text-decoration-none" target="_blank">
    //         <i class="fa-solid fa-plus"></i>
    //       </a>
    //       <a href="/Contracts/${row.id}/MaintenanceSchedules" class="text-decoration-none" target="_blank">
    //         <i class="fa-solid fa-pen"></i>
    //       </a>
    //     </div>`,
    // },
  ];

  // الأعمدة للطباعة (بدون عمود العمليات)
  const printColumns = [
    { title: "الشركة", data: "branch", render: (data) => data?.company?.name },
    {
      title: "تاريخ البدء",
      data: "start_date",
      render: (data) => format(new Date(data), "yyyy-MM-dd"),
    },
    {
      title: "تاريخ الانتهاء",
      data: "end_date",
      render: (data) => format(new Date(data), "yyyy-MM-dd"),
    },
    {
      title: "القيمة",
      data: "value",
    },
    { title: "الحالة", data: "status" },
    { title: "عدد زيارات الصيانة", data: "maintenance_visits" },
  ];

  return (
    <>
      <div className="main">
        <div className="container-fluid">
          <div className="row justify-content-between align-items-center mt-3">
            <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
              <div className="card py-2 px-3">
                <p className="mb-0 primary-100">عدد العناصر الفرعية: {maintenanceItems?.length}</p>
              </div>
            </div>
          </div>

          <div className="table-responsive" style={{ overflowX: "auto" }}>
            <div>
              <p className="text-center mb-0 fs-5">بحث</p>
            </div>

            {maintenanceItems && maintenanceItems.length > 0 && !loading && (
              <DataTable
                data={maintenanceItems}
                columns={screenColumns}
                className="display table table-striped table-bordered"
                options={{
                  responsive: true,
                }}
                ref={table}
              />
            )}
          </div>
        </div>
      </div>

      {/* <div className="print-only">
        <div className="header text-center py-3">
          <div class="logo d-flex mb-3 ">
            <figure class="me-3 mb-0">
              <img src={Logo} alt="logo" />
            </figure>
            <div>
              <h1 class="h5 mb-0 text-start"> بصمة خبرة لأدوات الأمن والسلامة</h1>
              <h1 class="h5 mb-0 text-start">Experience Mark For Safety & Security Tools</h1>
              <p class="mb-0" dir="ltr">
                Supply ,Installation & Maintenance توريد وتركيب وصيانة
              </p>
            </div>
          </div>
          <h1 className="text-dark">قسم الخدمة - صيانة روتينية</h1>
          <p className="text-muted">Experience Mark For Safety & Security Tools</p>
        </div>

        <div className="table-responsive d-flex justify-content-center align-items-center">
          <div className="table-container">
            {allContracts && allContracts.length > 0 && !loading && (
              <table className="display table table-bordered" style={{ width: "100%", border: "1px solid #000" }}>
                <thead>
                  {printColumns.map((col, index) => (
                    <th key={index} style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>
                      {col.title}
                    </th>
                  ))}
                </thead>
                <tbody>
                  {contracts.map((contract, index) => (
                    <tr key={index}>
                      {printColumns.map((col, colIndex) => (
                        <td key={colIndex} style={{ border: "1px solid #000", padding: "8px", textAlign: "center" }}>
                          {col.render ? col.render(contract[col.data], null, contract) : contract[col.data] || ""}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>

        <div className="footer py-3 text-center">
          <div className="row">
            <div className="col-6">
              <p>اسم العميل: ____________________</p>
              <p>توقيع العميل: ____________________</p>
            </div>
            <div className="col-6">
              <p>اسم التقني: ____________________</p>
              <p>توقيع التقني: ____________________</p>
            </div>
          </div>
          <p>التاريخ: {format(new Date(), "yyyy-MM-dd")}</p>
          <p>هذا ليس بوصل دفع. يرجى طلب الوصل عند الدفع.</p>
          <p>رقم الهاتف: 056 420 6066 | 053 134 4107 | البريد الإلكتروني: mabdellaziz@experience-mark.com</p>
        </div>
      </div> */}

      <style>
        {`
          .print-only {
            display: none;
          }
          @media print {
            .main, .print-hide {
              display: none;
            }
            .print-only {
              display: block;
              margin: 0;
              padding: 0;
              width: 100%;
              height: 100%;
            }
          
            .table-container {
              width: 90%;
              max-width: 1000px;
            }
            .table {
              border-collapse: collapse;
              width: 100%;
              border: 1px solid #000;
            }
            .table th, .table td {
              border: 1px solid #000;
              padding: 8px;
              text-align: center;
              font-size: 12px;
              color: #000;
            }
            .table th {
              background-color: #fff;
              font-weight: bold;
            }
          }
      
          .table-responsive {
            overflow-x: auto;
          }
        `}
      </style>
    </>
  );
}
